import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import DriveEtaOutlinedIcon from '@mui/icons-material/DriveEtaOutlined';
import NoCrashOutlinedIcon from '@mui/icons-material/NoCrashOutlined';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import PostAddIcon from '@mui/icons-material/PostAdd';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import WalletOutlinedIcon from '@mui/icons-material/WalletOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import FlakyOutlinedIcon from '@mui/icons-material/FlakyOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';


const getMenuItems = (t, userPermissions) => {
    const hasPermission = (permission) => userPermissions?.some(p => p.value === permission);


    return [
        hasPermission('dashboard') && { text: t('dashboard'), icon: <DashboardOutlinedIcon />, path: '/dashboard' },
        hasPermission('post') && {
            text: t('posts'), icon: <Inventory2OutlinedIcon />, path: '/posts', items: [
                { text: t('posts'), icon: <Inventory2OutlinedIcon />, path: '/posts', show: true },
                { text: t('addPost'), icon: <PostAddIcon />, path: '/add-post', show: true },
                { text: t('updatePost'), icon: <PostAddIcon />, path: '/posts/:id', show: false },
            ]
        },
        (hasPermission('page') || hasPermission('pagePayment')) && {
            text: t('pages'), icon: <FacebookOutlinedIcon />, path: '/pages', items: [
                { text: t('pages'), icon: <FacebookOutlinedIcon />, path: '/pages', show: hasPermission('page') },
                { text: t('pages'), icon: <FacebookOutlinedIcon />, path: '/pages/:id', show: false },
                { text: t('addPage'), icon: <AddCircleOutlineOutlinedIcon />, path: '/add-page', show: hasPermission('page') },
                { text: t('pagePayments'), icon: <PaymentOutlinedIcon />, path: '/page-payments', show: hasPermission('pagePayment') },
                { text: t('addPayment'), icon: <AddCardOutlinedIcon />, path: '/add-Page-payment', show: hasPermission('pagePayment') },
                { text: t('pagePayments'), icon: <PaymentOutlinedIcon />, path: '/page-payments/:id', show: false },
            ]
        },
        (hasPermission('driver') || hasPermission('driverPayment')) && {
            text: t('drivers'), icon: <DriveEtaOutlinedIcon />, path: '/drivers', items: [
                { text: t('drivers'), icon: <DriveEtaOutlinedIcon />, path: '/drivers', show: hasPermission('driver') },
                { text: t('drivers'), icon: <DriveEtaOutlinedIcon />, path: '/drivers/:id', show: false },
                { text: t('addDriver'), icon: <NoCrashOutlinedIcon />, path: '/add-driver', show: hasPermission('driver') },
                { text: t('driverPayments'), icon: <PaymentOutlinedIcon />, path: '/driver-payments', show: hasPermission('driverPayment') },
                { text: t('addPayment'), icon: <AddCardOutlinedIcon />, path: '/add-driver-payment', show: hasPermission('driverPayment') },
                { text: t('driverPayments'), icon: <PaymentOutlinedIcon />, path: '/driver-payments/:id', show: false },
            ]
        },
        hasPermission('expense') && {
            text: t('expenses'), icon: <PointOfSaleOutlinedIcon />, path: '/expenses', items: [
                { text: t('expenses'), icon: <CurrencyExchangeOutlinedIcon />, path: '/expenses', show: true },
                { text: t('expenseTypes'), icon: <CategoryOutlinedIcon />, path: '/expense-types/', show: true },
            ]
        },
        hasPermission('walletTransfer') && { text: t('walletTransfer'), icon: <WalletOutlinedIcon />, path: '/wallet-transfer' },
        hasPermission('loan') && {
            text: t('loans'), icon: <AccountBalanceIcon />, path: '/loans', items: [
                { text: t('loans'), icon: <AccountBalanceIcon />, path: '/loans', show: true },
                { text: t('addLoan'), icon: <AddOutlinedIcon />, path: '/add-loan', show: true },
                { text: t('updateLoan'), icon: <AddOutlinedIcon />, path: '/loans/:id', show: false },
            ]
        },
        hasPermission('report') && {
            text: t('report'), icon: <AssessmentOutlinedIcon />, path: '/profit-report', items: [
                { text: t('profit'), icon: <TrendingUpOutlinedIcon />, path: '/profit-report', show: true },
                { text: t('moneyMovement'), icon: <AttachMoneyOutlinedIcon />, path: '/money-report', show: true },
                { text: t('totalActivity'), icon: <SummarizeOutlinedIcon />, path: '/activity-report', show: true },
                { text: t('totalRemainings'), icon: <AccountBalanceWalletOutlinedIcon />, path: '/remainings-report', show: true },
            ]
        },
        hasPermission('notification') && {
            text: t('notifications'), icon: <NotificationsNoneOutlinedIcon />, path: '/notifications', items: [
                { text: t('notifications'), icon: <NotificationsNoneOutlinedIcon />, path: '/notifications', show: true },
                { text: t('addNotification'), icon: <NotificationAddOutlinedIcon />, path: '/add-notification', show: true },
            ]
        },
        hasPermission('whatsAppMsg') && {
            text: t('whatsAppMsg'), icon: <MailOutlineOutlinedIcon />, path: '/whatsapp-msgs', items: [
                { text: t('whatsAppMsg'), icon: <MailOutlineOutlinedIcon />, path: '/whatsapp-msgs', show: true },
                { text: t('addWhatsAppMsg'), icon: <ForwardToInboxOutlinedIcon />, path: '/add-whatsapp-msg', show: true },
            ]
        },
        (hasPermission('user') || hasPermission('role')) && {
            text: t('manageUser'), icon: <ManageAccountsOutlinedIcon />, path: '/users', items: [
                { text: t('users'), icon: <PersonOutlineOutlinedIcon />, path: '/users', show: hasPermission('user') },
                { text: t('users'), icon: <PersonOutlineOutlinedIcon />, path: '/users/:id', show: false },
                { text: t('addUser'), icon: <PersonAddAltOutlinedIcon />, path: '/add-user', show: hasPermission('user') },
                { text: t('roles'), icon: <VerifiedUserOutlinedIcon />, path: '/roles', show: hasPermission('role') }
            ]
        },
        (
            hasPermission('city') ||
            hasPermission('cityPrice') ||
            hasPermission('street') ||
            hasPermission('branch') ||
            hasPermission('postType') ||
            hasPermission('postStatus') ||
            // hasPermission('printer') ||
            hasPermission('blockedNumber') ||
            hasPermission('company')
        )
        && {
            text: t('settings'), icon: <SettingsOutlinedIcon />, path: '/cities', items: [
                { text: t('cities'), icon: <FlagOutlinedIcon />, path: '/cities', show: hasPermission('city') },
                { text: t('cityPrices'), icon: <MonetizationOnOutlinedIcon />, path: '/city-prices', show: hasPermission('cityPrice') },
                { text: t('streets'), icon: <ApartmentOutlinedIcon />, path: '/streets', show: hasPermission('street') },
                { text: t('branches'), icon: <AltRouteOutlinedIcon />, path: '/branches', show: hasPermission('branch') },
                { text: t('postTypes'), icon: <CategoryOutlinedIcon />, path: '/post-types', show: hasPermission('postType') },
                { text: t('postStatuses'), icon: <FlakyOutlinedIcon />, path: '/post-statuses', show: hasPermission('postStatus') },
                // { text: t('printers'), icon: <LocalPrintshopOutlinedIcon />, path: '/printers', show: hasPermission('printer') },
                { text: t('blockedNumbers'), icon: <BlockOutlinedIcon />, path: '/blocked-numbers', show: hasPermission('blockedNumber') },
                { text: t('companyInfo'), icon: <DomainOutlinedIcon />, path: '/company-info', show: hasPermission('company') },
            ]
        },

        { text: t('profile'), icon: <AccountCircleOutlinedIcon />, path: '/profile' },
    ].filter(Boolean);
};

export {
    getMenuItems
};
